import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {PilotTransferPoint} from "@portbase/bezoekschip-service-typescriptmodels";
import {Handler} from "../../../common/handlers/handler";
import {View} from "../../../common/handlers/view";
import {Observable} from "rxjs";
import {tap} from "rxjs/operators";

@Component({
  selector: 'app-edit-pilot-transfer-point',
  templateUrl: './edit-pilot-transfer-point.component.html',
  styleUrls: ['./edit-pilot-transfer-point.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
@Handler()
export class EditPilotTransferPointComponent extends View implements OnInit {
  @Input() transferPoint: PilotTransferPoint;
  @Output() transferPointChange = new EventEmitter<PilotTransferPoint>();

  protected nextTransferPoints: PilotTransferPoint[] = [];

  allPilotTransferPoints: Observable<PilotTransferPoint[]>;

  pilotTransferPointFormatter = (transferPoint: PilotTransferPoint) => transferPoint.name;

  ngOnInit() {
    this.allPilotTransferPoints = this.subscribeTo("getAllPilotTransferPoints")
      .pipe(tap((t: PilotTransferPoint[]) => this.nextTransferPoints =
        t.filter(t => this.transferPoint.nextTransferPoints.includes(t.pilotTransferPointId))));
  }

  onUpdate = () => this.sendCommand("updatePilotTransferPoint", this.transferPoint);

  setNextTransferPoints(transferPoints: PilotTransferPoint[]) {
    this.transferPoint.nextTransferPoints = transferPoints.map(t => t.pilotTransferPointId);
    this.onUpdate();
  }
}
